<template>
  <div class="c-account-modal">
    <el-select
      :value="accountName"
      :placeholder="placeholder"
      :disabled="disabled"
      :style="{ width: `${width}px` }"
      popper-class="c-visibility-hidden"
      multiple
      clearable
      collapse-tags
      @remove-tag="remove"
      @clear="gameClear"
      @focus="visible = true"
    >
      <span slot="empty"></span>
    </el-select>

    <!-- 账号选择弹窗 -->
    <Modal
      v-model="visible"
      title="选择账号"
      :width="960"
      :closable="false"
      :mask-closable="false"
      :transfer="false"
      class-name="vertical-center-modal"
      @on-visible-change="bindGetData"
    >
      <Row :gutter="20" class-name="c-form">
        <Col span="24">
          <Form inline>
            <FormItem :label-width="40" label="媒体">
              <el-select
                v-model="mediaIds"
                :popper-append-to-body="false"
                multiple
                collapse-tags
                filterable
                clearable
                placeholder="全部"
                style="width: 185px"
              >
                <el-option v-for="label in mediaData" :key="label.id" :value="label.id" :label="label.name"></el-option>
              </el-select>
            </FormItem>
            <FormItem :label-width="40" label="人员">
              <el-select
                v-model="opIds"
                :popper-append-to-body="false"
                multiple
                collapse-tags
                filterable
                clearable
                placeholder="全部"
                style="width: 190px"
              >
                <el-option v-for="label in operatorData" :key="label.id" :value="label.id" :label="label.name"></el-option>
              </el-select>
            </FormItem>
            <FormItem :label-width="0">
              <Button type="primary" size="small" class="m-search-btn" @click="query">查询</Button>
            </FormItem>
            <FormItem :label-width="0" class="g-pull-right">
              <Button :disabled="max === mult_account.length" ghost type="primary" size="small" @click="betchModel = true">批量导入</Button>
            </FormItem>
          </Form>
        </Col>
      </Row>
      <Row :gutter="20">
        <Col span="24">
          <selecter
            ref="accountSelect"
            v-model="mult_account"
            :data="accountData"
            :loading="loading"
            :max="max"
            @on-select="selectAll"
            @on-delete="delTag"
            @on-clear="handleClear"
          />
        </Col>
      </Row>
      <Row slot="footer" :gutter="12">
        <Button type="default" @click="cannel">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </Row>
    </Modal>
    <!-- 批量账号导入 -->
    <betch-import v-model="betchModel" :media-data="mediaData" :max="max" :result="mult_account" @on-select="betchAddACounts" />
  </div>
</template>
<script>
import { isArray, deepCopy, getIdOfData } from '@/common/js/utils'
import Selecter from './select/selecter.vue'
import BetchImport from './import.vue'
import { adAccount } from '@/api/common.model'

export default {
  name: 'AccountModal',
  components: { Selecter, BetchImport },
  props: {
    value: {
      type: Array,
      required: true
    },
    width: {
      type: Number,
      default: 180
    },
    max: {
      type: Number
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean
    },
    mediaData: {
      type: Array
    },
    operatorData: {
      type: Array
    }
  },
  computed: {
    accountId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      loading: null,
      visible: null,
      betchModel: null,

      opIds: [],
      mediaIds: [],
      mult_account: [],
      accountName: [],
      accountData: []
    }
  },
  methods: {
    bindGetData(val) {
      if (val) {
        this.query()
        this.temData = deepCopy(this.mult_account)
      } else {
        this.opIds = []
        this.mediaIds = []
        this.accountData = []
      }
    },
    gameClear() {
      this.$emit('input', [])
      this.handleClear()
    },
    handleClear() {
      const someAdData = this.accountData.some((ret) => ret.check)
      this.mult_account = []
      this.accountName = []
      if (someAdData) {
        this.accountData
          .filter((ret) => ret.check)
          .forEach((ret) => {
            this.$set(ret, 'check', false)
          })
      }
    },
    remove(tag) {
      const clearData = (tag, data) => {
        if (!isArray(data)) return
        data.some((ret) => {
          if (!isArray(ret.children)) {
            ret.name === tag && this.$set(ret, 'check', false)
            return ret.name === tag
          } else return clearData(tag, ret.children)
        })
      }
      clearData(tag, this.accountData) // 单清选择
      const index = this.mult_account.findIndex((ret) => ret.name === tag)
      index > -1 && this.mult_account.splice(index, 1) // 单清结果
      this.save()
    },
    // 全选
    selectAll({ list, check = true, current = '', cat }) {
      const id = current || cat
      if (id) {
        const item = getIdOfData(list, id)
        if (item && this.max > this.mult_account.length) {
          this.$set(item, 'check', check)
          this.checkItem(item)
        }
      } else if (isArray(list)) {
        // 全选
        list.every((ret) => {
          if (ret.children && ret.children.length) {
            return ret.children.every((rec) => {
              if (this.max <= this.mult_account.length) {
                this.$Message.error(`账号数量限制最多 ${this.max} ！`)
                return
              }
              this.$set(rec, 'check', check)
              this.checkItem(rec)
              return true
            })
          } else {
            if (this.max <= this.mult_account.length) {
              this.$Message.error(`账号数量限制最多 ${this.max} ！`)
              return
            }
            this.$set(ret, 'check', check)
            this.checkItem(ret)
            return true
          }
        })
      }
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getIdOfData(list, name)
      if (data.children && data.children.length) this.selectAll({ list, check: false, current: data.value })
      else this.$set(data, 'check', false)
      const index = this.mult_account.findIndex((ret) => ret.id === name)
      index > -1 && this.mult_account.splice(index, 1)
    },
    checkItem(params) {
      const { id, check } = params
      const isDul = this.mult_account.some((ret) => ret.id === id) // 查重

      if (check && !isDul) this.mult_account.push(params)
      else if (!check && isDul) {
        const index = this.mult_account.findIndex((ret) => ret.id === id)
        index > -1 && this.mult_account.splice(index, 1)
      }
    },
    save() {
      const ids = this.mult_account.map((ret) => ret.id)
      if (this.max < ids.length) {
        this.$Message.error(`超过了账号数量限制，请删减到 ${this.max} 以内！`)
        return
      }
      this.accountName = this.mult_account.map((ret) => ret.name)
      this.$emit('input', ids)
      this.visible = false
    },
    cannel() {
      this.visible = false
      this.mult_account = deepCopy(this.temData)
    },
    betchAddACounts(val) {
      this.selectAll({ list: val })
      this.betchModel = false
    },
    query(bool) {
      this.$refs.accountSelect && (this.$refs.accountSelect.keyword = '')

      this.loading = true
      this.accountData = []
      adAccount({
        authFlag: 1,
        opIds: this.opIds,
        mediaIds: this.mediaIds
      })
        .then((data) => {
          if (typeof data !== 'symbol') this.loading = false
          if (isArray(data)) {
            let defCheck
            if (bool) defCheck = this.mult_account.map((met) => met.id)
            else {
              defCheck = this.value
              if (!this.mult_account.length) this.mult_account = deepCopy(data.filter((ret) => this.value.includes(ret.id)))
            }
            this.accountData = data.map((ret) => {
              ret.check = defCheck.includes(ret.id)
              return ret
            })
          }
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-account-modal {
  position: relative;

  .c-form {
    flex: 0 0 auto;
    padding-bottom: 6px;
  }

  ::v-deep .ivu-btn {
    margin-left: 6px !important;
  }

  ::v-deep .ivu-modal-body {
    padding-top: 8px;
  }

  ::v-deep .ivu-form-item {
    margin-bottom: 0;
    text-align: left;
  }

  ::v-deep .el-input input {
    padding: 0 8px;
  }

  ::v-deep .el-select__tags {
    padding-left: 4px;
  }

  ::v-deep .el-select__input {
    margin-left: 2px;
  }

  ::v-deep .el-select .el-tag {
    margin-left: 4px;
    display: flex;
    align-items: center;

    .el-select__tags-text {
      max-width: 78px;

      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
</style>
